export function getSearchString(searchString) {
  if (searchString.indexOf('?') === 0) {
    searchString = searchString.slice(1)
  }
  return searchString;
}